import React, { useEffect, useContext, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';
import { Tooltip } from 'bootstrap';

function PosCounterCheckout() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [tableData, setTableData] = useState();
	const [posMobileSidebarToggled, setPosMobileSidebarToggled] = useState(false);
	const [selectedTable, setSelectedTable] = useState();
	var tooltip = [];
	
	function checkTime(i) {
		if (i < 10) {i = "0" + i};
		return i;
	}
	
	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = (h > 11) ? 'pm' : 'am';
		h = (h > 12) ? h - 12 : h;
	
		setTimeout(() => {
			getTime();
		}, 500);
		return h + ":" + m + a;
	}
	
	
	function toggleMobileSidebar(event, table) {
		event.preventDefault();
		
		setPosMobileSidebarToggled(true);
		setSelectedTable(table);
	}
	
	function dismissMobileSidebar(event) {
		event.preventDefault();
		
		setPosMobileSidebarToggled(false);
		setSelectedTable([]);
	}
	
	function getPrice(type) {
		var price = 0;
		
		if (selectedTable && selectedTable.orders) {
			var orders = selectedTable.orders;
			for (var i = 0; i < orders.length; i++) {
				if (type === 'subtotal') {
					price += parseFloat(orders[i].price);
				} else if (type === 'taxes') {
					price += parseFloat(orders[i].price) * 0.06;
				} else if (type === 'total') {
					price += parseFloat(orders[i].price);
					price += parseFloat(orders[i].price) * 0.06
				}
			}
		}
		
		return price.toFixed(2);
	}
	
	function getTotalPrice(orders) {
		var total = 0;
		if (orders) {
			for (var i = 0; i < orders.length; i++) {
				total += parseFloat(orders[i].price);
			}
		}
		return total.toFixed(2);
	}
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-0');
		
		var elm = document.querySelectorAll('.pos [data-bs-toggle="tooltip"]');
		for (var i = 0; i < elm.length; i++) {
			var t = new Tooltip(elm[i]);
			tooltip.push(t);
		}
		
		fetch('/assets/data/pos/counter-checkout.json').then(res => res.json()).then((result) => { setTableData(result); });
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
			
			if (tooltip) {
				for (var i = 0; i < tooltip.length; i++) {
					tooltip[i].dispose();
				}
			}
			const elements = document.querySelectorAll('.tooltip');
			elements.forEach(el => {
				el.remove();
			});
		};
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className={'pos pos-with-header pos-with-sidebar ' + ((posMobileSidebarToggled) ? 'pos-mobile-sidebar-toggled' : '')} id="pos">
			<div className="pos-container">
				<div className="pos-header">
					<div className="logo">
						<Link to="/">
							<div className="logo-img"><Icon icon="material-symbols-light:food-bank" /></div>
							<div className="logo-text">FOOD BANK</div>
						</Link>
					</div>
					<div className="time" id="time">{ time }</div>
					<div className="nav">
						<div className="nav-item">
							<Link to="/pos/counter-checkout" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Counter Checkout" className="nav-link active">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:shopping-cart-checkout-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/kitchen-order" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Kitchen Order" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:order-approve-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/table-booking" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Table Booking" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:calendar-month-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/menu-stock" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Menu Stock" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:inventory-2-outline-sharp" />
								</div>
							</Link>
						</div>
					</div>
				</div>
				
				<div className="pos-content">
					<div className="pos-content-container p-3">
						<div className="row g-3">
							{tableData && tableData.length > 0 ? (tableData.map((table, index) => (
								<div className="col-xl-3 col-lg-4 col-md-6" key={index}>
									<div className={'pos-checkout-table' + 
										((selectedTable && table.tableNo === selectedTable.tableNo) ? ' selected' : '') + 
										((!table.orders && table.status !== 'Reserved') ? ' available' : '') + 
										((table.orders) ? ' in-use' : '') +
										((table.status === 'Reserved') ? ' disabled' : '')
									}>
										<a href="#/" className="pos-checkout-table-container" onClick={(event) => toggleMobileSidebar(event, table)}>
											<div className="pos-checkout-table-header">
												<div className="status"><i className="bi bi-circle-fill"></i></div>
												<div className="fw-semibold small">Table</div>
												<div className="h1 mb-0">{table.tableNo}</div>
												<div className="small">
													{table.orders && (<span>{table.orders.length} order</span>)}
													{table.status === 'Reserved' && (<span>Reserved for {table.reserveName}</span>)}
													{!table.orders && table.status !== 'Reserved' && (<span>max { table.totalPax } pax</span>)}
												</div>
											</div>
											<div className="pos-checkout-table-info small">
												<div className="row">
													<div className="col-6 d-flex justify-content-center">
														<div className="w-20px fs-16px"><Icon icon="material-symbols-light:group-outline" className="d-block" /></div>
														<div className="w-60px">{table.pax} / {table.totalPax}</div>
													</div>
													<div className="col-6 d-flex justify-content-center">
														<div className="w-20px fs-16px"><Icon icon="material-symbols-light:nest-clock-farsight-analog-outline" className="d-block" /></div>
														<div className="w-60px">{(table.totalTime) ? table.totalTime : '-'}</div>
													</div>
												</div>
												<div className="row">
													<div className="col-6 d-flex justify-content-center">
														<div className="w-20px fs-16px"><Icon icon="material-symbols-light:receipt-outline" className="d-block" /></div>
														<div className="w-60px">${getTotalPrice(table.orders)}</div>
													</div>
													<div className="col-6 d-flex justify-content-center">
														<div className="w-20px fs-16px"><Icon icon="material-symbols-light:shopping-cart-checkout-sharp" className="d-block" /></div>
														<div className={'w-60px'+ ((table.status === 'Paid') ? ' text-success' : '')}>{(table.status !== 'Reserved') ? table.status : '-'}</div>
													</div>
												</div>
											</div>
										</a>
									</div>
								</div>
							))) : (
								<div className="col-12">
									No records found
								</div>
							)}
						</div>
					</div>
				</div>
			
				<div className="pos-sidebar" id="pos-sidebar">
					<div className="pos-sidebar-header">
						<div className="back-btn">
							<button type="button" onClick={dismissMobileSidebar} className="btn">
								<i className="fa fa-chevron-left"></i>
							</button>
						</div>
						<div className="icon"><i className="fa fa-plate-wheat"></i></div>
						<div className="title">Table {(selectedTable && selectedTable.tableNo) ? selectedTable.tableNo : '-'}</div>
						<div className="order">Order: <span className="fw-semibold">#{ (selectedTable && selectedTable.orderNo) ? selectedTable.orderNo : '-' }</span></div>
					</div>
					<PerfectScrollbar className="pos-sidebar-body h-100 py-0">
						{selectedTable && selectedTable.orders ? (selectedTable.orders.map((order, index) => (
							<div className="pos-order py-3" key={index}>
								<div className="pos-order-product">
									<div className="img" style={{backgroundImage: 'url('+ order.image +')'}}></div>
									<div className="flex-1">
										<div className="row">
											<div className="col-7">
												<div className="fw-semibold text-white">{ order.title }</div>
												<div className="mb-1">${ order.price }</div>
												{order.options && order.options.map((option, index) => (
													<div className="small" key={index}>- size: {option}</div>
												))}
											</div>
											<div className="col-2">x{ order.quantity }</div>
											<div className="col-3 fw-semibold text-white">${ (parseFloat(order.price) * order.quantity).toFixed(2) }</div>
										</div>
									</div>
								</div>
							</div>
						))) : (
							<div className="py-3">No records found</div>
						)}
					</PerfectScrollbar>
					
					<div className="pos-sidebar-footer">
						<div className="d-flex align-items-center mb-2">
							<div>Subtotal</div>
							<div className="flex-1 text-end h6 mb-0">${getPrice('subtotal')}</div>
						</div>
						<div className="d-flex align-items-center">
							<div>Taxes (6%)</div>
							<div className="flex-1 text-end h6 mb-0">${getPrice('taxes')}</div>
						</div>
						<hr />
						<div className="d-flex align-items-center mb-2">
							<div>Total</div>
							<div className="flex-1 text-end h4 mb-0">${getPrice('total')}</div>
						</div>
						<div className="mt-3">
							<div className="d-flex">
								<a href="#/" className="btn btn-secondary btn-sm w-70px">
									<span className="d-flex fs-24px justify-content-center mt-1"><Icon icon="material-symbols-light:cast-outline-sharp" /></span>
									<span>E-WALLET</span>
								</a>
								<span className="w-10px"></span>
								<a href="#/" className="btn btn-secondary btn-sm w-70px">
									<span className="d-flex fs-24px justify-content-center mt-1"><Icon icon="material-symbols-light:credit-card-outline-sharp" /></span>
									<span>BILL</span>
								</a>
								<span className="w-10px"></span>
								<a href="#/" className="btn btn-default btn-sm flex-fill">
									<span className="d-flex fs-24px justify-content-center mt-1"><Icon icon="material-symbols-light:account-balance-wallet-outline-sharp" /></span>
									<span>CASH</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PosCounterCheckout;